import { BASE_URL } from '../constant'

const EXCLUDED_ENDPOINTS = ['/login'];

const api = async (endpoint, options = {}) => {
    const token = localStorage.getItem('token');
    const shouldExcludeToken = EXCLUDED_ENDPOINTS.includes(endpoint);

    const headers = {
        ...options.headers,
        ...(shouldExcludeToken ? {} : { Authorization: `Bearer ${token}` }),
    };

    const updatedOptions = {
        ...options,
        headers,
    };

    try {
        const url = `${BASE_URL}${endpoint}`;
        const response = await fetch(url, updatedOptions);
        if (response.status === 401) {
            console.error('Unauthorized. Please log in again.');
            return;
        }
        return response;
    } catch (error) {
        console.error('Error in fetch request:', error);
        // throw error;
    }
};

export default api;
